import { Breakpoint } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material";

export const VIEW_POINT_CONFIG: Record<string, { from?: Breakpoint; to?: Breakpoint }> = {
  MOBILE: {
    to: "md",
  },
  DESKTOP: {
    from: "md",
  },
};

export const useCheckViewPoint = ({ from, to }: { from?: Breakpoint; to?: Breakpoint }) => {
  const theme = useTheme();
  let viewPoint = theme.breakpoints.up("xs");

  if (from && to) {
    viewPoint = theme.breakpoints.between(from, to);
  }
  if (from) {
    viewPoint = theme.breakpoints.up(from);
  }
  if (to) {
    viewPoint = theme.breakpoints.down(to);
  }

  const isActive = useMediaQuery(viewPoint as string);

  return isActive;
};
